// Central registry of mountable components.
// Add new components here so they can be referenced by name in ERB.

import UserCard from "./UserCard";
import LineChart from "./charts/LineChart";
import ScatterPlot from "./charts/ScatterPlot";
import ForestPlot from "./charts/ForestPlot";

export default {
	UserCard,
	LineChart,
	ScatterPlot,
	ForestPlot,
};
